import { OidcUserInfo, useOidcUser } from '@axa-fr/react-oidc'
import { useEffect, useState } from 'react'
import { appRoles } from '../config.tsx'

interface OidcUserRoleInfo extends OidcUserInfo {
  role?: string[]
}

const RouteGuard = ({ ...props }) => {
  const { oidcUser } = useOidcUser<OidcUserRoleInfo>()
  const [isAuthorized, setIsAuthorized] = useState(false)

  const onLoad = async () => {
    if (props.roles !== null && oidcUser !== null) {
      const intersection = props.roles.filter((role: string) => (oidcUser !== undefined ? oidcUser.role?.includes(role) : null))
      if (intersection.length > 0) {
        setIsAuthorized(true)
      } else {
        setIsAuthorized(false)
      }
      if (props.roles.includes(appRoles.Anonym)) {
        setIsAuthorized(true)
      }
    }
  }

  useEffect(() => {
    onLoad()
  })

  return (
    <>
      {isAuthorized ? (
        <>{props.children}</>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <div className="data-area-div" style={{ alignSelf: 'center' }}>
            <h3>Sie sind nicht autorisiert, diesen Inhalt zu sehen. Sie benötigen erweiterte Rechte!</h3>
          </div>
        </div>
      )}
    </>
  )
}

export default RouteGuard
